import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  HeadObject: {
    A_VocTyp: "",
    A_VocTypName: "",
    A_VocNo: 0,
    A_PostDt: new Date(), // dd/MM/yyyy
    A_RefDt: new Date(), // dd/MM/yyyy
    A_Party: "",
    A_PartyName: "",
    A_Type: "",
    A_Br: "", //LocationBrCode
    A_BrName: "", //location branchName
    A_Loc: "",
    A_LocName: "",
    A_Narr: "",
    A_DocStat: "ENTER",
    TaxType: "", //tax  ->      // INTRN001->VAT		INTRN002->INTER COMPANY  INTRN002->IMPORT
    TaxTypeName: "",
    //new
    A_FromLoc: "",
    A_FromLocName: "",
    A_ToLoc: "",
    A_ToLocName: "",
    A_FromTrn: "",
    A_ToTrn: "",
    CreditLimit: (0).toFixed(2),
    OsAmount: (0).toFixed(2),
    AvlAmt: (0).toFixed(2),
    TransferType: "",
  },
  // BufferObject: {
  //   B_VocTyp: "",
  //   B_VocNo: "",
  //   B_Srno: 0,
  //   B_Itmcd: "",
  //   B_ItmName: "",
  //   B_Qty: 0,
  //   B_Unit: "",
  //   B_UnitName: "",
  //   B_BaseQty: 0,
  //   B_URateFc: 0,
  //   B_URateLc: 0,
  //   B_GrossAmt: 0,
  //   B_LDiscPerc: 0,
  //   B_LDiscAmt: 0,
  //   B_TDiscPerc: 0.00,
  //   B_TDiscAmt: 0,
  //   B_FocFlag: "N",
  //   B_AprmtFlag: "",
  //   B_FocAmt: 0,
  //   B_NetAmt: 0,
  //   B_TaxDept: "",
  //   B_TaxPerc: 0,
  //   B_TaxAmt: 0,
  //   B_TaxDept2: "",
  //   B_TaxPerc2: 0,
  //   B_TaxAmt2: 0,
  //   B_LC: 0,
  //   B_Charges1: 0,
  //   B_Charges2: 0,
  //   B_Rounding: 0,
  //   B_LandVal: 0,
  //   B_RSP: 0,
  //   B_RefDocTyp: "",
  //   B_RefDocNo: "",
  //   B_RefNo1: "",
  //   B_RefNo2: "",
  //   B_RefNo3: "",
  //   B_RefNo4: 0,
  //   B_RefNo5: 0,
  //   B_RefNo6: 0,
  //   B_URate_Fixed: 0,
  //   B_CostPr: 0,
  //   B_ExciseTaxPerc: 0,
  //   B_ExciseTaxAmt: 0,
  //   B_ExciseTaxNetAmt: 0,
  //   B_IncGroup: "",
  //   B_SuprvPerc: 0,
  //   B_OthersPerc: 0,
  //   B_SLANSuprv: "",
  //   B_SlabAmtSuprv: 0,
  //   B_SLANOther: "",
  //   B_SlabAmtOther: 0
  // },

  WmsStockTransferCheckbox: { 
    Tax: true, 
  },
};

const SliceWmsStockTransfer = createSlice({
  name: "SliceWmsStockTransfer",
  initialState: { value: initialState },

  reducers: {
    //including   RESET ALL
    Set_WmsStockTransfer_Init: (state) => {
      state.value = initialState;
    },

    //RESET HEAD
    Set_WmsStockTransfer_HeadObject_Init: (state) => {
      state.value.HeadObject = initialState.HeadObject;
    },

    //RESET CHECKBOX
    Set_WmsInnModelCheckbox_Init: (state) => {
      state.value.WmsStockTransferCheckbox = {
        SplDisc: false,
        TDiscPercent: false,
        TDiscAmt: false,
        LDiscPercent: true,
        LDiscAmt: true,
        FOC: false,
        Excise: false,
        // BaseRate: false,
        Tax: true,
        Rebate: false,
        Narration: false,
        Cess: false,
        AddCess: false,
      };
    },

    Set_WmsStockTransfer_HeadObject_Set: (state, action) => {
      state.value.HeadObject = action.payload;
    },
    Set_WmsInnModelCheckbox: (state, action) => {
      state.value.WmsStockTransferCheckbox = action.payload;
    },

    Wms_StockTransfer_HeadObject_New_Set: (state, action) => {
      state.value.HeadObject.A_VocTyp = action.payload.A_VocTyp;
      state.value.HeadObject.A_VocTypName = action.payload.A_VocTypName;
      state.value.HeadObject.A_VocNo = action.payload.A_VocNo;
      state.value.HeadObject.A_FromLoc = action.payload.A_FromLoc;
      state.value.HeadObject.A_ToLoc = action.payload.A_ToLoc;
      state.value.HeadObject.A_FromTrn = action.payload.A_FromTrn;
      state.value.HeadObject.A_ToTrn = action.payload.A_ToTrn;
      state.value.HeadObject.TaxType = action.payload.TaxType;
      state.value.HeadObject.TransferType = action.payload.TransferType;
      state.value.HeadObject.A_Type = action.payload.A_Type;
    },
    Wms_StockTransfer_HeadObject_TypeDependency_Set: (state, action) => {
      state.value.HeadObject.A_FromLoc = action.payload.A_FromLoc;
      state.value.HeadObject.A_ToLoc = action.payload.A_ToLoc;
      state.value.HeadObject.A_FromTrn = action.payload.A_FromTrn;
      state.value.HeadObject.A_ToTrn = action.payload.A_ToTrn;
      state.value.HeadObject.TaxType = action.payload.TaxType;
    },
    Wms_StockTransfer_HeadObject_Type_Set: (state, action) => {
      state.value.HeadObject.A_Type = action.payload.A_Type;
    },
    Wms_StockTransfer_HeadObject_Party_Set: (state, action) => {
      state.value.HeadObject.A_Party = action.payload.A_Party;
      state.value.HeadObject.A_PartyName = action.payload.A_PartyName;
      state.value.HeadObject.CreditLimit = action.payload.CreditLimit;
      state.value.HeadObject.OsAmount = action.payload.OsAmount;
      state.value.HeadObject.AvlAmt = action.payload.AvlAmt;
    },

    Set_StockTransfer_HeadObject_A_VocNo: (state, action) => {
      state.value.HeadObject.A_VocNo = action.payload.A_VocNo;
      state.value.HeadObject.A_DocStat = action.payload.A_DocStat;
    },

    Set_StockTransfer_HeadObject_A_DocStat: (state, action) => {
      state.value.HeadObject.A_DocStat = action.payload.A_DocStat;
    },

    Set_StockTransfer_HeadObject_TaxType: (state, action) => {
      state.value.HeadObject.TaxType = action.payload.TaxType;
    },
    Set_StockTransfer_HeadObject_A_Type: (state, action) => {
      state.value.HeadObject.A_Type = action.payload.A_Type;
    },
  },
});

export const {
  Set_WmsStockTransfer_Init,
  Set_WmsStockTransfer_HeadObject_Set,
  Set_WmsInnModelCheckbox,
  Set_WmsInnModelCheckbox_Init,
  Wms_StockTransfer_HeadObject_New_Set,
  Set_WmsStockTransfer_HeadObject_Init,
  Set_StockTransfer_HeadObject_A_VocNo,
  Set_StockTransfer_HeadObject_A_DocStat,
  Set_StockTransfer_HeadObject_TaxType,
  Wms_StockTransfer_HeadObject_Party_Set,
  Wms_StockTransfer_HeadObject_TypeDependency_Set,
  Wms_StockTransfer_HeadObject_Type_Set,
  Set_StockTransfer_HeadObject_A_Type,
} = SliceWmsStockTransfer.actions;
export default SliceWmsStockTransfer.reducer;
